import * as React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { colorFacetsBlue900, colorFacetsNeutralLight300, typographyFontsSans } from '@netlify/netlify-design-tokens';
import { getStripe } from '../../../modules/Subscription';
import PaymentForm from './PaymentForm';

type Props = {
    clientSecret: string;
    subscriptionId: string;
    tierId: string;
    projectId: string;
    onPaymentStart?: () => void;
    onPaymentSuccess?: () => void;
    onPaymentFailure?: (message: string) => void;
    onPromotionCodeUpdate?: (status: 'start' | 'success' | 'fail', amount?: number) => void;
};

const CheckoutForm = (props: Props) => (
    <Elements
        options={{
            clientSecret: props.clientSecret,
            appearance: {
                variables: {
                    fontFamily: typographyFontsSans,
                    fontSizeSm: '14px'
                },
                rules: {
                    '.Label': {
                        marginBottom: '8px',
                        fontWeight: '500',
                        color: colorFacetsBlue900
                    },
                    '.Input': {
                        fontSize: '14px',
                        padding: '12px 16px',
                        borderRadius: '0',
                        borderColor: colorFacetsNeutralLight300,
                        boxShadow: 'none',
                        transition: 'none'
                    },
                    '.Input:focus': {
                        borderColor: '#4c57c5',
                        boxShadow: 'none'
                    },
                    '.Input:hover:focus': {
                        borderColor: '#4c57c5'
                    },
                    '.Input:hover': {
                        borderColor: '#848480'
                    },
                    '.Input::placeholder': {
                        color: '#676879'
                    }
                }
            }
        }}
        stripe={getStripe()}
    >
        <PaymentForm
            projectId={props.projectId}
            tierId={props.tierId}
            subscriptionId={props.subscriptionId}
            onPaymentSuccess={props.onPaymentSuccess}
            onPaymentFailure={props.onPaymentFailure}
            onPaymentStart={props.onPaymentStart}
            onPromotionCodeUpdate={props.onPromotionCodeUpdate}
        />
    </Elements>
);

export default CheckoutForm;
